<template>
  <div class="">
    <el-row :gutter="20">
      <el-col :span="12" style="border: 1px solid #fff">
        <div v-if="isRandom">
          <span style="text-align: left; margin-right: 20px">{{
            blindName
          }}</span>
          <el-button
            type="primary"
            icon="el-icon-refresh-right"
            size="mini"
            style="text-align: left"
            @click="goBack"
            >返回</el-button
          >
        </div>
      </el-col>
      <el-col :span="12" class="btn">
        <div>
          <el-button
            v-if="isRandom"
            type="primary"
            icon="el-icon-folder-add"
            size="small"
            @click="goManualTest"
            >手动测试</el-button
          >
          <el-button
            type="primary"
            icon="el-icon-folder-add"
            size="small"
            @click="addTest"
            >添加测试</el-button
          >
          <el-button
            type="primary"
            icon="el-icon-delete"
            size="small"
            @click="handleEmptyData"
            >清空数据</el-button
          >
        </div>
      </el-col>
    </el-row>
    <div class="container-table">
      <el-table
        ref="filterTable"
        stripe
        size="mini"
        :data="autoData"
        style="width: 100%"
        :header-cell-style="tableHeaderColor"
        border
        :cell-style="cellStyle"
      >
        <el-table-column type="index" width="80" label="测试编号" />
        <el-table-column prop="name" label="测试名称" width="450">
          <template slot-scope="scope">
            <div style="font-size: 12px">{{ scope.row.name }}</div>
          </template>
        </el-table-column>
        <el-table-column prop="num" label="测试人数" />
        <el-table-column prop="unit_num" label="参与单位数量" width="300" />
        <el-table-column prop="repeat_num" label="测试重复次数" />
        <el-table-column prop="create_time" label="创建时间" />
        <el-table-column prop="create_time" label="创建进度" width="180">
          <template slot-scope="scope">
            <div>
              {{
                progressCount(scope.row) === "100%"
                  ? "完成"
                  : progressCount(scope.row)
              }}
            </div>
          </template>
        </el-table-column>
        <el-table-column fixed="right" label="操作">
          <template slot-scope="scope">
            <div
              v-if="progressCount(scope.row) === '100%'"
              slot="content"
              style="color: #85a5ff"
            >
              <el-link
                type="primary"
                :underline="false"
                class="edit"
                @click="handleExports(scope.row)"
                >下载</el-link
              >
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!--分页-->
    <div class="pages">
      <el-pagination
        samll
        background
        :current-page="currentPage"
        :page-sizes="[10, 20, 30, 40]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>
    <!--创建测试-->
    <el-dialog
      center
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      width="40%"
      @close="handleCancel"
    >
      <div slot="title" class="title">创建测试</div>
      <div class="proInfo">
        <el-row class="row">
          <el-col :span="6" class="left">测试名称：</el-col>
          <el-col :span="18">
            <el-input v-model="name" size="mini" type="text" />
          </el-col>
        </el-row>
        <el-row class="row">
          <el-col :span="6" class="left">测试人数：</el-col>
          <el-col :span="18">
            <el-input
              v-model="num"
              size="mini"
              type="number"
              @mousewheel.native.prevent
            />
          </el-col>
        </el-row>
        <el-row class="row">
          <el-col :span="6" class="left">参与单位：</el-col>
          <el-col :span="18">
            <el-select
              v-model="unit"
              style="width: 100%"
              placeholder="请选择"
              size="mini"
              multiple
              collapse-tags
              @change="changeUnit"
            >
             <el-checkbox
              v-model="isAllUnit"
              style="margin-left: 10px"
              @change="allUnit"
              >全选
            </el-checkbox>
              <el-option
                v-for="item in unitData"
                :key="item.name"
                :label="item.name"
                :value="item.id"
              />
            </el-select>
          </el-col>
        </el-row>
        <el-row class="row">
          <el-col :span="6" class="left">测试重复次数：</el-col>
          <el-col :span="18">
            <el-input
              v-model="repeat_num"
              size="mini"
              type="number"
              @mousewheel.native.prevent
            />
          </el-col>
        </el-row>
        <!--<el-row class="row">-->
        <!--<el-col :span="6" class="left">因子概率偏差：</el-col>-->
        <!--<el-col :span="18">-->
        <!--<el-input v-model="scale" size="mini" type="number" @mousewheel.native.prevent />-->
        <!--</el-col>-->
        <!--</el-row>-->
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button
          size="mini"
          type="primary"
          :loading="loading"
          @click="handleAutosub"
          >确 定</el-button
        >
        <el-button size="mini" @click="handleCancel">取 消</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { autoTest, autoTestAdd, cleanData, exportTest } from "@/api/test";
import { getProjectId, getRandom } from "@/utils/auth";
import { detailPro } from "@/api/homePage";

export default {
  name: "BlindAutomaticTest",
  data() {
    return {
      cellStyle: {
        textAlign: "center",
      },
      currentPage: 1,
      pageSize: 10,
      total: null,
      isAllUnit:false,
      proId: "",
      dialogVisible: false,
      value1: "",
      autoData: [],
      name: "",
      num: null,
      unit: [],
      repeat_num: null,
      scale: null,
      bindId: "",
      unitData: [],
      getRandom: "",
      isRandom: true,
      blindName: "",
      loading: false,
      timer: "",
      userDetail: JSON.parse(sessionStorage.getItem("iwrs_user")),
    };
  },
  computed: {
    progressCount() {
      return function (item) {
        const i = item.num * item.repeat_num;
        const reasult = Number.parseInt(item.now_count) / i;
        const progress = parseFloat(reasult).toFixed(2) * 100 + "%";
        return progress;
      };
    },
  },
  created() {
    this.proId = getProjectId();
    this.getRandom = getRandom();
    if (this.getRandom === "动态随机") {
      this.isRandom = false;
    }
    this.bindId = this.$route.query.id;
    this.blindName = this.$route.query.name;
    this.getAutoList();
    this.getUnitList(); // 获取单位
    this.$once("hook:beforeDestroy", () => {
      clearInterval(this.timer);
    });
  },
  methods: {
    changeUnit(val){
     val && val.length === this.unitData?.length
        ? (this.isAllUnit = true)
        : (this.isAllUnit = false);
    },
    allUnit(state){
      if (state) {
        this.unitData.forEach(item => {
          this.unit.push(item.id);
        });
        var arr = [];
        for (var i = 0; i < this.unit.length; i++) {
          if (!arr.includes(this.unit[i])) {
            arr.push(this.unit[i]);
          }
        }
        this.unit = arr;
      } else {
        this.unit = [];
      }
    },
    handleExports(row) {
      let urltest =
        sessionStorage.getItem("iwrs_environment") === "PROD"
          ? "2/v1.0/iwrs/blind_test/export"
          : "/v1.0/iwrs/blind_test/export";
      const baseUrl =
        process.env.VUE_APP_BASE_API +
        urltest +
        "?project_id=" +
        this.proId +
        "&test_id=" +
        row.id +
        "&user_id="+
        this.userDetail.id;
      console.log(baseUrl);
      // console.log(exportTest);
      window.open(baseUrl, "_blank");
    },
    getUnitList() {
      detailPro({ id: this.proId }).then((res) => {
        if (res && res.code === 0) {
          this.unitData = res.data.blind_unit_list.map((item) => {
            const obj = {};
            obj.name = item.name;
            obj.id = item.id;
            return obj;
          });
          // console.log(this.unitData);
        }
        console.log(res);
      });
    },
    handleCancel() {
      this.name = "";
      this.num = null;
      this.isAllUnit=false;
      this.unit = [];
      this.repeat_num = null;
      this.scale = null;
      this.dialogVisible = false;
      this.getAutoList();
    },
    checkVal() {
      if (!this.name) {
        this.$message({
          message: "请输入测试名称",
          type: "warning",
        });
        return false;
      }
      if (!this.num) {
        this.$message({
          message: "请输入测试人数",
          type: "warning",
        });
        return;
      }
      if (!this.unit) {
        this.$message({
          message: "请选择参与单位",
          type: "warning",
        });
        return;
      }
      if (!this.repeat_num) {
        this.$message({
          message: "请输入测试重复次数",
          type: "warning",
        });
        return;
      }
      // if (!this.scale) {
      //   this.$message({
      //     message: '请输入因子概率偏差',
      //     type: 'warning'
      //   })
      //   return
      // }
      return true;
    },
    handleAutosub() {
      if (this.checkVal()) {
        this.loading = true;
        const params = {
          project_id: this.proId,
          name: this.name,
          num: this.num,
          unit_id_list: this.unit,
          repeat_num: this.repeat_num,
          // scale: this.scale,
          blind_id: this.bindId,
        };
        autoTestAdd(params)
          .then((res) => {
            if (res && res.code === 0) {
              this.getStatus();
              // this.loading = false;
              this.handleCancel();
              this.$message({
                message: res.msg,
                type: "success",
              });
            } else {
              // this.loading = false;
              this.$message.error(res.msg);
            }
          })
          .catch((res) => {
            console.log(res.msg);
          }).finally(() =>{
             this.loading = false;
          })
      }
    },
    getStatus() {
      console.log("运行乐");
      this.getAutoList();
      const timer2 = setTimeout(() => {
        this.getStatus();
      }, 5000);
      this.$once("hook:beforeDestroy", function () {
        clearTimeout(timer2);
      });
    },
    getAutoList() {
      const params = {
        project_id: this.proId,
        page: this.currentPage - 1,
        page_size: this.pageSize,
        blind_id: this.bindId,
      };
      autoTest(params)
        .then((res) => {
          if (res && res.code === 0) {
            if (res.data && res.data.length > 0) {
              this.autoData = res.data;
              this.total = res.total;
            } else {
              this.autoData = [];
            }
          } else {
            this.$message.error(res.msg);
          }
        })
        .catch((res) => {
          console.log(res);
        });
    },
    addTest() {
      this.dialogVisible = true;
    },
    // 清空数据
    handleEmptyData() {
      if (this.manualData != "") {
        this.$confirm(
          `是否确认 <span style="color: #698CFC;font-size: 14px;font-weight: bold;">清空数据</span>?`,
          "提示",
          {
            dangerouslyUseHTMLString: true,
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            cancelButtonClass: "btn-custom-cancel",
            center: true,
            type: "warning",
          }
        ).then(() => {
          const param = {
            project_id: this.proId,
            method: "自动测试",
            blind_id: this.bindId,
          };
          cleanData(param)
            .then((res) => {
              if (res && res.code === 0) {
                this.getAutoList();
                this.$message({
                  message: res.msg,
                  type: "success",
                });
              } else {
                this.$message.error(res.msg);
              }
            })
            .catch((res) => {
              console.log(res.msg);
            });
        });
      }
    },
    goBack() {
      this.$router.push({
        path: "/blindFundus/index",
      });
    },
    // 切换至手动测试
    goManualTest() {
      this.$router.push({
        path: "/blindFundus/blindTest",
        query: {
          id: this.bindId,
        },
      });
    },
    // 每页条数
    handleSizeChange(val) {
      this.pageSize = val;
      this.currentPage = 1;
      this.getAutoList();
    },
    // 当前页数
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getAutoList();
    },
    tableHeaderColor({ row, column, rowIndex, columnIndex }) {
      // 改表头颜色
      if (rowIndex === 0) {
        return "background-color: #D6E4FF;color: #595959;text-align:center;";
      }
    },
  },
};
</script>

<style scoped>
.btn {
  text-align: right;
}
.container-table {
  margin-top: 20px;
}
.title {
  padding: 15px 0;
  background-color: #d6e4ff;
  color: #595959;
  font-weight: 500;
  font-size: 16px;
}
.proInfo {
  background-color: #f0f5ff;
  padding: 20px 30px;
}
.row {
  margin: 20px 0;
  font-size: 14px;
  color: #595959;
}
.left {
  line-height: 26px;
  text-align: right;
}
.pages {
  margin-top: 30px;
  text-align: right;
}
.edit {
  font-size: 12px;
  margin-right: 10px;
}
.desc {
  font-size: 12px;
  color: #8c8c8c;
  margin-top: 5px;
  text-align: center;
}
</style>
<style>
.el-dialog__header {
  padding: 0px;
}
.container-table {
  border: 1px solid #e5eeff;
}
.el-tooltip__popper.is-light {
  border: none;
  background: #ffffff;
  box-shadow: 0px 6px 16px 0px rgba(0, 0, 0, 0.08),
    -1px -1px 12px 0px rgba(0, 0, 0, 0.12);
}
.popper__arrow {
  border: none !important;
}

.btn-custom-cancel {
  /* float: right; */
  margin-left: 10px;
}
.el-table__column-filter-trigger i {
  color: #000;
  font-size: 14px;
}
.diaBg {
  background-color: #f0f5ff;
  padding: 20px;
}
.el-message-box .el-message-box__btns {
  display: flex !important;
  justify-content: center;
  flex-direction: row-reverse;
}
</style>
